import d3 from '~/kits/general/scripts/d3';
import { sortByKey } from '~/core/scripts/utils';
import { getDateOfISOWeek } from '~/kits/general/scripts/utils';

export function extendData(chartWidth, chartHeight) {
  return (d) => {
    const dataSorted = d.data.sort(sortByKey('date', false));
    const yMax = d3.max(d.data, d => d.abs);
    const startDate = new Date(d.startYear, 10, 3); //getDateOfISOWeek(40, d.startYear);
    const endDate = new Date(d.endYear, 4, 22); //getDateOfISOWeek(20, d.endYear);

    const xScale = d3.scaleTime()
      .domain([startDate, endDate])
      .range([0, chartWidth]);

    const yScale = d3.scaleLinear()
      .domain([0, yMax + (yMax * 0.2)])
      .range([chartHeight, 0])
      .clamp(true);

    const line = d3.line()
      .x(d => xScale(d.date))
      .y(d => yScale(d.abs))
      .curve(d3.curveCardinal);

    return {
      ...d,
      xScale,
      yScale,
      line,
      yMax,
      data: dataSorted
    };
  };
}